import questions from "../../assets/js/helpMultilngual/bs_de_questions";
import troubles from "../../assets/js/helpMultilngual/bs_en_troubles";
const de = {
  language: "Deutschland",
  helpCenter: {
    documentTitle: "Helpcenter",
    title: [
      "Fahrzeug verknüpfen & freischalten",
      "Probleme mit dem Konto",
      "Fahren",
      "ADAS",
      "Informationen und Unterhaltung",
      "App-Nutzungsanleitung",
      "Fahrzeug-Update",
      "Akku-Sicherheit",
      "Wartung",
      "Selbstüberprüfung auf Fehler"
    ],
    description: "Description:",
    solution: "Suggested Solution:",
    exAssistance: "Batteriewechsel-Hilfe",
    exAssistanceList: [
      "Über den BlueShark Smart Batteriewechselservice",
      "Über das Batteriewechselkonto",
      "Über die Batteriewechselpläne",
      "Informationen zur Nutzung des Batteriewechseldienstes"
    ],
    exAssistanceSubtitle: [
      ["Über den BlueShark Smart Batteriewechselservice"],
      [
        "Wie erhalte ich ein Batteriewechselkonto?",
        "Welche Verwendungen hat ein Batterietausch-Konto?"
      ],
      [
        "Was ist ein Batteriewechselplan?",
        "Kann das verbleibende Kontingent dieses Monats auf den nächsten Monat übertragen und dort verwendet werden?",
        "Ist es möglich, eine Rückerstattung für den gekauften Batteriewechselplan zu erhalten?",
        "Ist es möglich, den gekauften Batteriewechselplan zu erneuern?",
        "Welche Regeln gelten für das Inkrafttreten des Batteriewechselplans?"
      ],
      [
        "Nach dem Kauf des Plans, wie führe ich den ersten Batteriewechsel durch?",
        "Wie führt man einen Batteriewechsel durch?",
        "Wie kann ich die Batterieinformationen an verschiedenen Standorten der Batteriewechselstation überprüfen?",
        "Welche möglichen Gründe gibt es für einen fehlgeschlagenen Batteriewechsel?"
      ]
    ],
    exAssistanceInfo: [
      [
        [
          "Der Blueshark Smart Battery Swapping Service ist ein schneller Energienachfülldienst, den Blueshark für spezifische Märkte anbietet. Dies umfasst die Installation von Batteriewechselstationen, das Angebot von Batteriemietdiensten und Wechselfunktionen. Er behebt effektiv das Problem unzureichender Reichweite bei elektrischen Motorrädern und ermöglicht eine Auffüllung und Batteriewechsel in nur 3 Sekunden.",
          "Aufgrund unterschiedlicher Nachfragesituationen in verschiedenen Märkten deckt der Blueshark Smart Battery Swapping Service nicht alle Verkaufsregionen von Blueshark-Fahrzeugen vollständig ab. In einigen Verkaufsbereichen werden entsprechende Batteriewechsel- und Nachfülldienste nicht angeboten. Für spezifische Details wenden Sie sich bitte an lokale Verkaufsstellen oder Händler."
        ]
      ],
      [
        [
          "Wenn der Blueshark Smart Battery Swapping Service in Ihrer Region verfügbar ist, müssen Sie zunächst die Blueshark-App herunterladen und erfolgreich ein App-Konto registrieren. Auf der Startseite der App finden Sie die Funktion 'Battery Swapping Service'.",
          "Wählen Sie die Funktion 'Battery Swapping Service', wählen Sie einen geeigneten Batterietausch-Betreiber aus, lesen Sie die 'Battery Swapping Service-Vereinbarung' und stimmen Sie ihr zu. Anschließend können Sie Ihr Tauschkonto erstellen.",
          "Wenn der Blueshark Smart Battery Swapping Service in Ihrer Region noch nicht verfügbar ist, können Sie nicht auf die Funktion 'Battery Swapping Service' zugreifen und kein Batterietausch-Konto erstellen."
        ],
        [
          "Das Batterietausch-Konto ist das einzige Identitätskonto, das für den Zugriff auf den Blueshark Smart Battery Swapping Service verwendet wird. Ohne ein Batterietausch-Konto können Sie die Vorteile des Batterietauschdienstes nicht nutzen. Das Batterietausch-Konto kann für den Kauf von Tauschpaketen, die Nutzung des Tauschdienstes, die Verwaltung von Tauschlimits und -werten sowie die Verfolgung von Tauschaufzeichnungen und -verbrauch verwendet werden."
        ]
      ],
      [
        [
          "Batterietauschpläne sind virtuelle elektronische Waren von Vorteilen, die von verschiedenen Batterietauschanbietern aufgrund der spezifischen Anforderungen von Tauschgeschäften in verschiedenen Regionen angeboten werden.",
          "Derzeit unterstützen die Planregeln drei Abrechnungsmethoden: Abrechnung basierend auf dem Stromverbrauch, Abrechnung basierend auf der Anzahl der Batterietauschvorgänge und unbegrenzte Batterietauschkontingente. Die Kontingente werden monatlich zugeteilt, und die Abrechnung kann monatlich, vierteljährlich oder jährlich erfolgen. Die konkreten verfügbaren Pläne hängen von den tatsächlichen Regeln ab, die vom gewählten Anbieter festgelegt wurden.",
          "Nach dem Kauf eines Batterietauschplans können Sie die Vorteile der Batterietauscherdienste nutzen. Sie können stationäre Geschäfte oder Händler aufsuchen, um Ihre Batterietauscher-Vorteile zu beanspruchen, und dann den Tauschdienst nutzen."
        ],
        [
          "Gemäß den aktuellen Regeln des Batteriewechseldienstes wird jedes nicht genutzte Kontingent für den aktuellen Monat beim Eintritt in den Abrechnungszyklus des nächsten Monats zurückgesetzt und wird sich nicht im nächsten Monat ansammeln. Bitte wählen Sie einen Batteriewechselplan, der Ihren tatsächlichen Stromverbrauchsbedürfnissen für den täglichen Gebrauch entspricht."
        ],
        [
          "Batteriewechselpläne sind virtuelle Vorteile in Form von elektronischen Waren, und gemäß den Regeln für die Nutzung des Batteriewechsels sind Rückerstattungen nicht möglich. Wir empfehlen, Ihren Kauf sorgfältig zu überdenken, um Verluste zu vermeiden. Vielen Dank für Ihr Verständnis."
        ],
        [
          "Bei Kauf eines Batteriewechselplans beachten Sie bitte die Erneuerungsregeln des Plans. Solange Sie die Erneuerungskriterien erfüllen, ist es möglich, den Plan zu erneuern. Nach der Erneuerung werden Ihre Batteriewechselvorteile weiterhin auf der Seite 'Mein Wechseln' akkumuliert. Bitte treffen Sie Pläne und Erneuerungen entsprechend Ihren tatsächlichen Bedürfnissen."
        ],
        [
          "Nach dem Kauf eines Batterietauschplans wird dieser ab dem 1. Tag des nächsten Monats wirksam. Bitte beachten Sie, dass Sie bei sofortiger Wirkung die Option 'Sofortige Anwendung im aktuellen Monat' auswählen und sicherstellen sollten, dass das Plan-Kontingent für den aktuellen Monat ausreichend ist. Dies ermöglicht eine sofortige Aktivierung des Batterietauschplans. Beim Kauf eines Batterietauschplans sollten Sie die Aktivierungszeit der Pläne entsprechend Ihren persönlichen Bedürfnissen vernünftig planen."
        ]
      ],
      [
        [
          "Nach dem Kauf des Batterietauschplans ist der erste Schritt, den Anweisungen der App zu folgen und ein stationäres Geschäft oder den Standort eines Händlers aufzusuchen, um die Vorteile des Batterietauschdienstes in Anspruch zu nehmen und die Batterie zu registrieren. Wenn es sich um eine geleastete Batterie handelt, musst du ein stationäres Geschäft oder den Standort eines Händlers aufsuchen, um die Batterie zu leasen und die Batterie-Leasingkaution zu bezahlen.",
          "Sobald die Batterie registriert ist, ist sie berechtigt, die Vorteile des Batterietauschdienstes zu nutzen. Du kannst die Batterie in die Batterietauschstation einsetzen, und die Station wird automatisch eine vollständig aufgeladene oder hochkapazitive Batterie ausgeben und die Vorteile des Batterietauschdienstes an die neu ausgegebene Batterie binden."
        ],
        [
          "Nachdem der Benutzer die erstmalige Batterieregistrierung für den ersten Tausch abgeschlossen hat, muss für jeden folgenden Batterietausch lediglich eine schwach geladene Batterie in einen leeren Steckplatz in der Batterietauschstation eingesetzt werden. Die Station wird automatisch eine vollständig aufgeladene oder hochkapazitive Batterie ausgeben.",
          "Falls die Batterietauschstation die Batterie nicht wie erwartet ausgibt, folgen Sie den Anweisungen auf dem Bildschirm der Station und kontaktieren Sie den Kundenservice für Unterstützung."
        ],
        [
          "Sie können den Batterietauscherdienst in der Blueshark-App auswählen, zur Startseite der Batterietauscherkarte gehen und Informationen zu nahegelegenen Batterietauschstationen finden. Diese Informationen umfassen den Namen der Station, den Standort, die Entfernung zu Ihnen und einen Überblick über den Batteriestatus. Durch Klicken auf eine bestimmte Batterietauschstation können Sie auf deren detaillierte Informationsseite zugreifen und die Batterieinformationen für diese ausgewählte Station anzeigen."
        ],
        [
          "Es gibt mehrere mögliche Gründe für einen fehlgeschlagenen Batterietausch:",
          "① Die eingesetzte Batterie hat einen abgelaufenen Batterietauscherdienst, was einen erfolgreichen Tausch verhindert. Sie sollten den Dienst vor der Nutzung erneuern.",
          "② Die Batterietauschstation hat keine verfügbaren Batterien für den Tausch, was bedeutet, dass die Batterien in der Station nicht den Tauschbedingungen entsprechen. In diesem Fall können Sie es an einer anderen Station versuchen",
          "③ Wenn keine der oben genannten Situationen zutrifft und Sie dennoch wiederholt Probleme beim Batterietausch haben, wenden Sie sich bitte an den Kundensupport für Unterstützung."
        ]
      ]
    ],
    quickGuide: "Schnellstartanleitung für Fahrzeuge",
    quickGuideList: [
      "Grundoperationen",
      "Fahrzeugaktivierung",
      "Parkfunktion",
      "Fahrzeugfunktion",
      "Fahren und Modus"
    ],
    QuickListSubtitle: [
      ["Grundoperationen für H1 2023", "Grundbedienung von R1 2023"],
      ["H1 2023 Fahrzeugaktivierung", "R1 2023 Fahrzeugaktivierung"],
      ["H1 2023 Parkfunktion", "R1 2023 Parkfunktion"],
      ["H1 2023 Fahrzeugfunktion", "R1 2023 Fahrzeugfunktion"],
      ["H1 2023 Fahren und Modus", "R1 2023 Fahren und Modus"]
    ],
    h1Node:
      "Hinweis: Dieser Leitfaden gilt nur für H1 2023. Für H1 lite beachten Sie bitte die Bedienungsanleitung. Dieser Leitfaden dient nur zur schnellen Inbetriebnahme. Für detaillierte Vorgänge beachten Sie bitte die Bedienungsanleitung.",
    r1Node:
      "Hinweis: Dieser Leitfaden gilt nur für R1 2023. Für R1 lite beachten Sie bitte die Bedienungsanleitung. Dieser Leitfaden dient nur zur schnellen Inbetriebnahme. Für detaillierte Vorgänge beachten Sie bitte die Bedienungsanleitung.",
    lightDescription: "Erklärung der Kontrollleuchten",
    signalLeft: "Linker Blinker",
    signalRight: "Rechter Blinker",
    highBeam: "Fernlicht",
    lowBeam: "Abblendlicht",
    lowPowerLight: "Batteriewarnleuchte",
    faultLight: "Störungsanzeige",
    readyLight: "Bereitschaftsanzeige",
    instrumentPic: "Diagramm des Armaturenbretts",
    leftKeyDescription: "Tastenanweisungen (linker Lenker)",
    leftHandPic: "Diagramm des linken Lenkers",
    rightKeyDescription: "Tastenanweisungen (rechter Lenker)",
    rightHandPic: "Rechter Lenker-Schematismus",
    overtakingLightKey:
      "Überhollichtschalter: Schalten Sie das Licht zum Blinken um",
    lowBeanKey:
      "Abblendlichtschalter: Umschalten, um das Abblendlicht einzuschalten",
    highBeamKey:
      "Fernlichtschalter: Umschalten, um das Fernlicht einzuschalten",
    configKey:
      "Bestätigungstaste: Wird für Bestätigungsvorgänge in der Smart Card verwendet",
    smartKey:
      "Smart Key: Wird zum Umschalten und zur Steuerung in der Smart Card verwendet",
    LeftTrunSignalKey:
      "Blinkerhebel: Nach links bewegen, um den linken Blinker zu aktivieren, in der Mitte drücken, um den Blinker auszuschalten",
    RightTrunSignalKey:
      "Blinkerhebel: Nach rechts bewegen, um den rechten Blinker zu aktivieren, in der Mitte drücken, um den Blinker auszuschalten",
    hornKey:
      "Hupe-Taste: Mit der Hand gedrückt halten, um zu hupen, loslassen, um das Hupen zu beenden",
    cruiseControlKey:
      "Tempomat-Taste: Kurz drücken, um den Tempomat zu aktivieren (bei Fahrzeuggeschwindigkeit über 15 km/h), erneut kurz drücken oder bremsen, um den Tempomat zu deaktivieren",
    waringKey:
      "Warnblinklicht-Taste: Zum Aktivieren der Warnblinklichter im Falle eines Fahrzeugfehlers oder Notfalls drücken.",
    costomKey: "Benutzerdefinierter Schlüssel: wird aktualisiert",
    turboKey:
      "TURBO-Taste: Kurzes Drücken zum Betreten des TURBO-Modus, erneutes Kurzes Drücken zum Verlassen",
    sportKey:
      "SPORT-Taste: Kurzes Drücken zum Betreten des SPORT-Modus, erneutes Kurzes Drücken zum Verlassen",
    openSeatKey:
      "Sitzbuckel-Taste: Kurzes Drücken zum Öffnen des Sitzbuckels, wenn das Fahrzeug eingeschaltet ist",
    transferAssistanceKey:
      "Assistenz-Bewegungstaste: Wenn das Fahrzeug in Fahrtzustand und im Stillstand ist, drücken Sie die MAM-Taste, um in den Assistenz-Bewegungsmodus zu gelangen. Zu diesem Zeitpunkt können Sie das Fahrzeug langsam vorwärts und rückwärts bewegen, indem Sie das 'M' oder den Lenker drehen.",
    gearKey: "Modustaste: Kurz drücken, um den Modus zu wechseln",
    LeftGearKey: "Schalttaste: Bei Linksdrehung herunterschalten",
    RightGearKey: "Schalttaste: Beim Rechtsdrehen hochschalten",
    volumeIncreaseKey:
      "Lautstärkeregelungstaste: Kurzes Drücken der rechten Taste erhöht die Lautstärke",
    volumedecreaseKey:
      "Lautstärkeregelungstaste: Kurzes Drücken der linken Taste, um die Lautstärke zu verringern",
    readyKey:
      "Bereit-Taste: Kurzes Drücken zum Wechsel zwischen Fahr- und Parkmodus",
    activationNode:
      "Hinweis: Das Fahrzeug ist bei Lieferung inaktiv und muss aktiviert werden, um alle Funktionen und Dienste nutzen zu können.",
    activeCardPic: "Fahrzeugaktivierungskarte Illustration",
    activeUIPic: "Fahrzeugaktivierungsschnittstellen-Illustration",
    activeStep1: "Schritt 1: Erste Startseite",
    activeStep2: "Schritt 2: App-Download-Anleitung",
    activeStep3: "Schritt 3: Aktivierungsseite Anleitung",
    activeStep4: "Schritt 4: Aktivierungs-Ergebnisseite",
    activeStepInfo1:
      "Wenn diese Karte auf dem Fahrzeug erscheint, drücken Sie ",
    activeStepInfo2: "kurz, um den Aktivierungsprozess zu starten",
    activeStepInfo3:
      "Die App kann im Android/iOS-Markt heruntergeladen werden. Wenn bereits heruntergeladen, drücken Sie",
    activeStepInfo5: "kurz, um zum nächsten Schritt zu gelangen",
    activeStepInfo6:
      "Folgen Sie den App-Anweisungen, um das Fahrzeug zu suchen, das entsprechende Fahrzeug zu finden und den 4-stelligen PIN-Code einzugeben, der auf dem Fahrzeugdashboard angezeigt wird, um die Aktivierung abzuschließen.",
    activeStepInfo7:
      "Nach erfolgreicher Aktivierung werden Sie zur Erfolgseite umgeleitet (Bitte beachten Sie, dass Sie diese Operation innerhalb von 5 Minuten abschließen müssen, sonst wird der Aktivierungsprozess neu gestartet.)",
    instrumentDescription: "Gesamtbeschreibung des Armaturenbretts",
    instrumentStopPic: "Instrumententafel (geparkter Zustand) Schaubild",
    instrumentWorkPic: "Instrumententafel (Fahrstatus) Darstellung",
    cardPic: "Aggregatkartenillustration",
    instrumentInfo1:
      "Smartcard-Bereich (einschließlich Aggregatkarten, Fahrstatistiken, Bluetooth-Musik, Bluetooth-Einstellungen, Fahrzeuggesundheit, Fahrzeugeinstellungen)",
    instrumentInfo2:
      "Zentrale Informationsbereich (einschließlich Fahrzeuggesundheitsstatus, Fahrzeugfahrstatistiken)",
    instrumentInfo3:
      "Fahrzeuginformationsbereich (einschließlich Modusposition, Reichweiteninformationen, Funktionsaktivierungsstatus)",
    aggregatedCardArea: "Smartcard-Bereich - Aggregatkarten",
    aggregatedCardInfo1:
      "Zeigen Sie den Wiedergabestatus von Bluetooth-Musik an, der Status der Musikfunktion kann anhand des Aufforderungstexts in der Musikfunktion beurteilt werden",
    aggregatedCardInfo2:
      "Zeigen Sie den Verbindungsstatus von Bluetooth an, wenn nicht verbunden, ist die Symbolfarbe grau, wenn erfolgreich verbunden, ist die Symbolfarbe bunt",
    aggregatedCardInfo3:
      "Zeigen Sie den Ein-Aus-Status des Fahrrekorders an, wenn nicht eingeschaltet, ist die Symbolfarbe grau, wenn eingeschaltet, ist die Symbolfarbe bunt",
    aggregatedCardInfo4:
      "Die Funktion ist noch nicht verfügbar, bitte bleiben Sie dran",
    cyclingStatistics: "Smartcard-Bereich - Fahrstatistiken",
    cyclingPic: "Radfahren Statistikillustration",
    cyclingStatisticsInfo1:
      "Hier wird die Gesamtfahrleistung des Fahrzeugs seit Verlassen des Werks angezeigt",
    cyclingStatisticsInfo2:
      "Hier wird Ihre Fahrleistung für eine bestimmte Fahrt angezeigt. Sie können",
    cyclingStatisticsInfo3: "kurz drücken, um diese Daten zurückzusetzen.",
    BluetoothMusic: "Smartcard-Bereich - Bluetooth-Musik",
    BluetoothPic: "Bluetooth-Musikillustration",
    BluetoothMusicInfo1:
      "Wenn Audio vorhanden ist, werden hier der Sänger und der Liedtext angezeigt. Wenn kein Audio vorhanden ist, wird hier 'Unbekanntes Lied' angezeigt (Bluetooth-Verbindung und Audiowiedergabe über ein mobiles Gerät erforderlich)",
    BluetoothMusicInfo2: "Drücken Sie kurz",
    BluetoothMusicInfo3: ", um die Musikwiedergabe/Pause zu steuern",
    BluetoothMusicInfo4: "Drücken Sie",
    BluetoothMusicInfo5: "lange, um zum nächsten Lied zu wechseln",
    vehicleHealth: "Smartcard-Bereich - Fahrzeuggesundheit",
    healthPic: "Fahrzeuggesundheit Illustration",
    warningPic: "Fahrzeuganomalie Illustration",
    vehicleHealthInfo1:
      "Nach dem Start des Fahrzeugs wechseln Sie zu dieser Karte, und es wird automatisch der Gesundheitszustand des Fahrzeugs erfasst",
    vehicleHealthInfo2:
      "Wenn Probleme mit dem Gesundheitszustand des Fahrzeugs auftreten, werden die entsprechenden Fehlerinformationen in der Karte angezeigt, und die Fehlerdetails können durch kurzes Drücken der ",
    vehicleHealthInfo3: "-Taste eingesehen werden",
    vehicleSetting: "Smartcard-Bereich - Fahrzeugeinstellungen",
    settingPic: "Fahrzeugeinstellungsdiagramm",
    vehicleSettingInfo1:
      "Diese Funktion ermöglicht es Ihnen, das Fahrzeug einzurichten (Einstellungen umfassen: Bluetooth-Lautstärke, Motorradsound, Anzeigemodus, Fahrzeugversion, Spracheinstellungen, Fahrdatenschreiber, Werksreset, Sicherheitsassistenz, ausstehender Bindungsmodus, Entfernungs- und Zeiteinheiten)",
    vehicleSettingInfo2:
      "Um zwischen verschiedenen Funktionen zu wechseln, können Sie",
    vehicleSettingInfo3: "kurz drücken, um die Steuerung auszuführen",
    vehicleSettingInfo4:
      "Wenn Sie die gewünschte Funktion finden und bestätigen möchten, können Sie",
    vehicleSettingInfo5: "kurz drücken, um zu bestätigen",
    instrumentWorkingInfo1:
      "Smartcard-Bereich (einschließlich aggregierter Karten, Fahrradstatistiken, Bluetooth-Musik)",
    instrumentWorkingInfo2:
      "Zentrale Informationsbereich (einschließlich Echtzeitgeschwindigkeit, Batterieinformationen)",
    instrumentWorkingInfo3:
      "Fahrzeuginformationsbereich (einschließlich Modusposition, Reichweiteninformationen, Echtzeitstrom, Echtzeit-Stromverbrauch)",
    aggregatedCardWorkingInfo2: "Aktuelle Radfahrdaten anzeigen",
    startCycling: "Fahren beginnen",
    startInfo:
      "Drücken Sie kurz die Taste 'Ready', um in den Fahrradmodus zu wechseln oder diesen zu verlassen. Das Armaturenbrett zeigt den entsprechenden Bildschirm an (siehe unten für Details)",
    gearShift: "Moduswechsel",
    gearNote:
      "Hinweis: Das Fahrzeug verfügt über insgesamt fünf Modi, nämlich 【ECO】【COMFORT】【SPORT】【TURBO】【MAM】",
    H1GearNote:
      "Hinweis: Das Fahrzeug verfügt insgesamt über vier Modi: 【ECO】, 【COMFORT】, 【SPORT】 und 【MAM】.",
    gearInfo1:
      "Der ECO-Modus ist für energiesparendes Fahren geeignet und bietet die längste Reichweite",
    gearInfo2:
      "Der COMFORT-Modus ist für den täglichen Gebrauch geeignet und balanciert Reichweite, Beschleunigung und Spitzengeschwindigkeit aus.",
    gearInfo3:
      "Der SPORT-Modus ist für sportliches Fahren geeignet und betont das Überholen und die Spitzengeschwindigkeitsleistung.",
    gearInfo4:
      "Der TURBO-Modus ist für intensives Fahren geeignet und entfesselt das volle Potenzial des Fahrzeugs.",
    gearInfo5: "MAM-Modus ist zum Schieben/Bewegen des Fahrzeugs geeignet",
    gearInfo6:
      "Schalte Modi durch Bewegen der M-Taste nach links oder rechts um",
    gearInfo7:
      "Drücken Sie die TURBO-Taste, um in den TURBO-Modus zu gelangen.",
    gearInfo8:
      "Halten Sie diese Taste gedrückt, um in den MAM-Modus zu gelangen, und drehen Sie dann den Griff oder schalten Sie M- / M+ um, um die Fahrzeugbewegung zu steuern (M- für Rückwärts; M+ für Vorwärts)",
    gearInfo9: "Drücken Sie die M-Taste, um die Modi zu wechseln",
    gearInfo10:
      "Drücken und halten Sie diese Taste, um in den MAM-Modus zu wechseln. Anschließend können Sie mit M-/M+ die Fahrzeugbewegung steuern (M- für Rückwärtsfahren; M+ für Vorwärtsfahren).",
    drivingPage: "Fahrseite",
    parkingPage: "Parkseite",
    gearPic: "Modusinformationsanzeigebereichsdiagramm",
    questions,
    troubles
  }
};

export default de;



// WEBPACK FOOTER //
// ./src/i18n/langs/de.js